import { render, staticRenderFns } from "./Associates.vue?vue&type=template&id=562ef16c&"
import script from "./Associates.vue?vue&type=script&lang=ts&"
export * from "./Associates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports